// googleMapsConfig.js
export const googleMapsConfig = {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    id: "google-map-script",
    libraries: ["places"], // Add all required libraries here (e.g., 'places', 'maps')
  };
  